import React from 'react';
import PropTypes from 'prop-types';
// import Icon from 'react-icons-kit';
// import { iosPlusEmpty } from 'react-icons-kit/ionicons';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import _ from 'lodash';
import Modal from 'react-modal';
import Cookies from 'js-cookie';
// import { styled } from "@mui/material/styles";
// import { withStyles } from '@mui/styles';
import EditDeviceNew from './EditDeviceNew';
import '../css/AllDevices.css';
import CountUp from 'react-countup';
import AddDeviceNew from './AddDeviceNew';
import AddDeviceNew1 from './AddDeviceNew1';
import processDriverData from '../processDriverData';
import minus from './../assets/images/minus.svg'
import plus from './../assets/images/plus.svg'
import edit from './../assets/images/edit.svg'
import view from './../assets/images/view.svg'
import deleteIcon from './../assets/images/delete.svg';
import PlusModal from './../assets/images/PlusModal.svg';
// import createHistory from 'history/createBrowserHistory';
//device icons
import appleTv from './../assets/images/deviceIcons/appleTv.svg'
import avp from './../assets/images/deviceIcons/avp.svg'
import bluray from './../assets/images/deviceIcons/bluray.svg'
import kaleidescape from './../assets/images/deviceIcons/kaleidescape.svg'
import lightCover from './../assets/images/deviceIcons/lightCover.svg'
import mediaPlayer from './../assets/images/deviceIcons/mediaPlayer.svg'
import projector from './../assets/images/deviceIcons/projector.svg'
import satellite from './../assets/images/deviceIcons/satellite .svg'
import thermostat from './../assets/images/deviceIcons/thermostat.svg'
import tv from './../assets/images/deviceIcons/tv.svg'
import defaultIcon from './../assets/images/deviceIcons/defaultIcon.svg'
import lift from './../assets/images/deviceIcons/lift.svg'
import toggleLift from './../assets/images/deviceIcons/lift.svg'
import swivelLift from './../assets/images/deviceIcons/lift.svg'
import securitySystem from './../assets/images/deviceIcons/securitySystem.svg'
import doorPhone from './../assets/images/deviceIcons/doorPhone.svg'
import accessControl from './../assets/images/deviceIcons/accessControl.svg'
import camera from './../assets/images/deviceIcons/camera.svg'
import { is_allowed } from '../utilitis';

//all devices page of master device section
const customStylesDelete = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '40%',
    minHeight: '40%',
    overflow: 'auto',
    padding: '2%',
  }
};

const styles = theme => ({
  root: {
    display: 'flex',
    // flexWrap: 'wrap',
  },
  formControl: {
    // margin: theme.spacing.unit,
    minWidth: 120,
    width: '100%',
    border: 'none'
  },
  selectEmpty: {
    // marginTop: theme.spacing.unit * 2,
    width: '100%',
  },
});

class AllDevices extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false,
      modalIsOpenEdit: false,
      modalIsOpenDelete: false,
      modalIsOpenDeleteSuccess: false,
      noOfParams: [],
      noOfParamsEdit: [],
      deviceList: [],
      age: '',
      device_group: '',
      deviceGroupEdit: [],
      currentDeviceToEdit: {},
      addDeviceButtonActive: false,
      dataDeviceType: [],
      deviceTypeSelected: '',

      //states for connectiontype dropdown
      connectionTypeDropdown: '',
      connectionTypeDropdownEdit: '',

      //states for devicemodel: device and type of input deviceEdit
      IOType: '',

      connectiontypeDropdownList: [],
      error: false,
      errorMessage: '',

      //states for modal open for new modal from new component
      activeModalNew: false,
      activeModalNewEdit: false,
      deviceSelected: {},

      //states related to delete
      deviceIdToDelete: null,

      //states related to Add New Device Type
      modalIsOpenDeviceType: false,

    };
    this.openModal = this.openModal.bind(this);
    this.openModalEdit = this.openModalEdit.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeModalEdit = this.closeModalEdit.bind(this);
    this.closeModalDelete = this.closeModalDelete.bind(this);

  }

  closeModalDelete() {
    this.setState({
      modalIsOpenDelete: false
    });
  }

  componentDidMount() {
    this.fetchDevices()

  }

  clean = (obj) => {
    for (var propName in obj) {
      if (typeof obj[propName] == "object")
        this.clean(obj[propName])
      if (obj[propName] === null || obj[propName] === undefined)
        delete obj[propName];
    }
  }



  fetchDevices = () => {
    this.setState({
      modalIsOpen: false,
      modalIsOpenEdit: false,
      modalIsOpenDelete: false,
      noOfParams: [],
      noOfParamsEdit: [],
      deviceList: [],
      age: '',
      device_group: '',
      deviceGroupEdit: [],
      currentDeviceToEdit: {},
      addDeviceButtonActive: false,
      dataDeviceType: [],
      // deviceTypeSelected: '',
      deviceTypeSelected: this.state.deviceTypeSelected,

      //states for connectiontype dropdown
      connectionTypeDropdown: '',
      connectionTypeDropdownEdit: '',

      //states for devicemodel: device and type of input deviceEdit
      IOType: '',

      connectiontypeDropdownList: [],
      error: false,
      errorMessage: '',

      //states for modal open for new modal from new component
      activeModalNew: false,
      activeModalNewEdit: false,
      deviceSelected: {},

      //states related to delete
      deviceIdToDelete: null,

      //states related to Add New Device Type
      modalIsOpenDeviceType: false,
    })
    var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`;

    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
    }
    fetch('/cloud/device_cloudApi/', {
      method: "GET",
      headers: headers,
    })
      .then(response => {
        if (response.status === 403) {
          localStorage.removeItem('token');
          localStorage.removeItem('csrftoken');
          localStorage.removeItem('auth');
          // const history = createHistory({forceRefresh: true})
          window.location.href = '/session-timeout'
        } else {
          return response.json()
        }
      })
      .then(data => {
        // console.log(data)
        var dataDeviceType = [];
        data.forEach((e) => {
          dataDeviceType.push(e.device_type)
        })
        dataDeviceType = _.uniq(dataDeviceType);
        this.setState({
          deviceList: data,
          dataDeviceType
        })
      })
      .catch((err) => {
        console.log(err)

      })
  }
  openModal() {
    this.setState({ modalIsOpen: true });
  }
  openModalEdit() {
    this.setState({ modalIsOpenEdit: true });
  }
  afterOpenModal() {
    // references are now sync'd and can be accessed.
    // this.subtitle.style.color = '#f00';
  }

  closeModal() {
    this.setState({ modalIsOpen: false });
  }
  closeModalEdit() {
    this.setState({ modalIsOpenEdit: false });
  }

  onDelete = (e) => {
    this.setState({
      deviceIdToDelete: e
    }, () => {
      this.setState({
        modalIsOpenDelete: true
      })
    })
  }

  onDeleteFinal = (e) => {
    var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
    }
    console.log("Device ID to delete:", this.state.deviceIdToDelete);
    fetch(`/cloud/device_cloudApi_Detail/${this.state.deviceIdToDelete}`, {
      method: "DELETE",
      headers: headers,
      body: JSON.stringify({ hello: "hello" })
    })
      .then(response => {
        if (response.status === 403) {
          localStorage.removeItem('token');
          localStorage.removeItem('csrftoken');
          localStorage.removeItem('auth');
          // const history = createHistory({forceRefresh: true})
          window.location.href = '/session-timeout'
        } else {
          return response.json()
        }
      })
      .then(data => {
        this.fetchDevices()
        this.setState({
          modalIsOpenDelete: false,
          modalIsOpenDeleteSuccess: true
        })
      })
      .catch((err) => {
        console.log(err)

      })
  }




  onEditNew = (e) => {
    // alert("bbbb")
    var deviceToEdit = e;
    var deviceSelected = this.state.deviceList.filter((deviceEdit) => {
      if (deviceEdit.device_id === deviceToEdit) {
        return deviceEdit
      }
    });
    this.setState({ deviceSelected }, () => {
      if (!this.state.activeModalNewEdit) {
        this.setState({
          activeModalNewEdit: true
        })
      } else {
        this.setState({
          activeModalNewEdit: false
        }, () => {
          this.setState({
            activeModalNewEdit: true
          })
        })
      }
    })
  }

  ActiveNewModal = (e) => {
    if (this.state.activeModalNew) {
      return <AddDeviceNew1 activeModal={true} refreshDevice={this.fetchDevices.bind(this)} />
    } else {
      return null
    }
  }
  ActiveNewModalEdit = (e) => {
    if (this.state.activeModalNewEdit) {
      return <EditDeviceNew
        activeModal={true}
        device={this.state.deviceSelected[0]}
        refreshDevice={this.fetchDevices.bind(this)}
      />
    } else {
      return null
    }
  }

  onClickAddDeviceButton = () => {
    if (!this.state.activeModalNew) {
      this.setState({
        activeModalNew: true
      })
    } else {
      this.setState({
        activeModalNew: false
      }, () => {
        this.setState({
          activeModalNew: true
        })
      })
    }
  }

  numberOfDeviceType = (deviceType) => {
    let numberOfDeviceType = 0;
    this.state.deviceList.forEach((e) => {
      if (e.device_type === deviceType) {
        numberOfDeviceType = numberOfDeviceType + 1;
      }
    })
    return numberOfDeviceType
  }

  deviceIcon = (type) => {
    var icon = {
      "light_cover": lightCover,
      "tv": tv,
      "projector": projector,
      "bluray": bluray,
      "thermostat": thermostat,
      "avp": avp,
      "lift": lift,
      "toggle_lift": toggleLift,
      "swivel_lift": swivelLift,
      "media_player": mediaPlayer,
      "satellite": satellite,
      "camera": camera,
      "security_system": securitySystem,
      "door_phone": doorPhone,
      "access_control": accessControl,
    }
    if (icon[type] !== undefined)
      return (<img src={icon[type]} style={{ verticalAlign: 'text-bottom', marginLeft: '10px', marginRight: '20px', width: '25px', height: '25px' }} />)
    else
      return (<img src={defaultIcon} style={{ verticalAlign: 'text-bottom', marginLeft: '10px', marginRight: '20px', width: '25px', height: '25px' }} />)
  }

  toggleDeviceType = (currentdeviceType) => {
    if (this.state.deviceTypeSelected !== currentdeviceType) {
      this.setState({
        deviceTypeSelected: currentdeviceType
      })
    } else {
      this.setState({
        deviceTypeSelected: ''
      })
    }
  }
  overlayShadowUnderModal = (type) => {
    if (type === 'overlay') {
      if (this.state.activeModalNew || this.state.activeModalNewEdit) {
        return (
          <div style={{ position: 'absolute', height: `${window.innerHeight - 60}px`, width: `${window.innerWidth - 260}px`, backgroundColor: 'rgba(0,0,0,0.75)', zIndex: '0', display: '' }}></div>
        )
      } else {
        return null
      }
    } else if (type === 'scroll') {
      return 'hidden'
    }
  }
  render() {
    // const { classes } = this.props;
    return (
      <React.Fragment>
        {this.overlayShadowUnderModal('overlay')}
        <div style={{ width: '100%', paddingLeft: '5px', paddingTop: '40px', paddingRight: '20px', }}>
          <div style={{ marginBottom: '20px' }}>
            <span style={{ color: '#888888', fontSize: '30px', }}>TOTAL DEVICES (<CountUp end={this.state.deviceList.length} delay={5} />)
            </span>
            <span style={{ float: 'right' }}>
              
              {true ? <div className="row" style={{ margin: '0' }}>
                <div className="pointer" onClick={(e) => { this.onClickAddDeviceButton() }}>
                
               
                      <div className="buttonContent" style={{ backgroundColor: 'white', boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2)' }}>

                        {/* <Icon icon={iosPlusEmpty} size={40} style={{ color: "#F08100", backgroundColor: "none", }} /> */}
                        <IconButton sx={{
                          color: '#F08100',
                          fontSize: 40,
                          backgroundColor: 'transparent',
                          '&:hover': {
                            backgroundColor: 'transparent'
                          },
                          '&:focus': {
                            outline: 'none',
                            border: 'none',
                            backgroundColor: 'transparent'
                          }
                        }} aria-label="add">
                          <AddIcon sx={{ fontSize: 40 }} />
                        </IconButton>
                        <span style={{ color: '#888888', fontSize: '10px', fontWeight: '600' }}>ADD NEW DEVICE</span>
                      </div>
                
                </div>
              </div> : null}
            </span>
          </div>
          {this.ActiveNewModal()}
          {this.ActiveNewModalEdit()}
          <div className="device-list">
            <div className="container" style={{ maxHeight: `${window.innerHeight - 180}px`, overflowY: 'auto', maxWidth: 'inherit' }}>
              <div className="row">
                {this.state.dataDeviceType.map((currentdeviceType, index) => {
                  return (
                    <div className="col-lg-12x deviceTypeMargin p-0" key={index} style={{ width: '100%' }}>
                      <div className="btnselfDeviceType">
                        {this.state.deviceTypeSelected !== currentdeviceType ? <img src={plus} style={{ verticalAlign: 'baseline', marginLeft: '10px', marginRight: '10px', cursor: 'pointer' }}
                          onClick={this.toggleDeviceType.bind(this, currentdeviceType)} /> : <img src={minus} style={{ verticalAlign: 'baseline', marginLeft: '10px', marginRight: '10px', cursor: 'pointer' }} onClick={this.toggleDeviceType.bind(this, currentdeviceType)}
                        />}
                        {this.deviceIcon(currentdeviceType)}
                        <span className="list-view-text my-3 text-capitalize">{currentdeviceType}({this.numberOfDeviceType(currentdeviceType)})</span>
                      </div>
                      {this.state.deviceTypeSelected !== currentdeviceType ? null : <div className="underSectionPage">
                        <div className="row p-1">
                          {this.state.deviceList.map((e, index) => {
                            if (e.device_type === currentdeviceType) {
                              return (
                                <div className="p-1 " key={index} style={{ width: '50%' }}>
                                  <div className="btnself">
                                    {this.deviceIcon(currentdeviceType)}
                                    <span className="list-view-text my-3 text-capitalize">{e.device_name.substring(0, 20)}</span>
                                    <div
                                      style={{ float: 'right', }} className="py-2 pointer"
                                      // className="fas fa-pencil-alt fa-2x pull-right icon-button px-2 py-2" 
                                      onClick={this.onEditNew.bind(this, e.device_id)}>
                                      <img src={edit} alt="" style={{ width: '20px', height: '20px', marginRight: '15px', marginTop: 'auto', marginBottom: 'auto' }} />
                                    </div>
                                    <div style={{ float: 'right', }} className="py-2 pointer"
                                      // className="fadr fa-trash-aldt fa-d2x pull-right icon-button px-2 py-2"
                                      onClick={this.onDelete.bind(this, e.device_id)}>
                                      <img src={deleteIcon} alt="" style={{ width: '20px', height: '20px', marginRight: '15px', marginTop: 'auto', marginBottom: 'auto' }} />
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          })}
                        </div>
                      </div>}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        <Modal
          isOpen={this.state.modalIsOpenDelete}
          style={customStylesDelete}
          contentLabel="Example Modal">
          <div className="modal-add-device">
            <div className="float-right cross-times" onClick={this.closeModalDelete}>
              <i className="fas   fa-2x mr-2"></i>
            </div>
          </div>
          <div className="display-4 text-center">
            <h3 className="modal-heading thanks-message">Are you sure for deletion </h3>
            <i class="fas  fa-question-circle update"></i>
            <br />
            <div className="btn reset-btn mx-2 px-5" onClick={this.onDeleteFinal.bind(this)}>Delete </div>
          </div>
        </Modal>
        <Modal
          isOpen={this.state.modalIsOpenDeleteSuccess}
          style={customStylesDelete}
          contentLabel="Example Modal">
          <div className="modal-add-device">
            <div className="float-right cross-times"
              onClick={() => {
                this.setState({
                  modalIsOpenDeleteSuccess: false
                })
              }}>
              <i className="fas   fa-2x mr-2"></i>
            </div>
          </div>
          <div className="display-4 text-center">
            <h3 className="modal-heading thanks-message">Device deleted successfully.</h3>
            <i class="fas fa-check-circle update"></i>
            <br />
            <div className="btn reset-btn mx-2 px-5" onClick={() => {
              this.setState({
                modalIsOpenDeleteSuccess: false
              })
            }}>Close</div>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}


AllDevices.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default AllDevices;

